import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import html2canvas from "html2canvas-pro";
import L from "leaflet";
import ArrowDownTrayIcon from "@heroicons/react/24/outline/ArrowDownTrayIcon";
import { renderToStaticMarkup } from "react-dom/server";

const MapDownloadControl: React.FC = () => {
  const map = useMap();

  useEffect(() => {
    const onClick = () => {
      const mapElement = document.querySelector(".leaflet-container");
      if (mapElement) {
        html2canvas(mapElement as any, {
          useCORS: true,
          allowTaint: false,
          scale: 1,
          logging: true,
        }).then((canvas) => {
          const dataURL = canvas.toDataURL("image/png");
          const link = document.createElement("a");

          link.download = "map-capture.png";
          link.href = dataURL;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        });
      }
    };

    const control = new L.Control({ position: "bottomright" });

    control.onAdd = () => {
      const container = L.DomUtil.create("div", "leaflet-bar leaflet-control");

      const button = L.DomUtil.create("button", "", container);
      button.innerHTML = renderToStaticMarkup(
        <ArrowDownTrayIcon className="h-5 w-5 mx-auto" color="#0c4a6e" />,
      );
      button.title = "Download PNG";

      Object.assign(button.style, {
        backgroundColor: "white",
        width: "32px",
        height: "32px",
        border: "1px solid #0c4a6e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        borderRadius: "8px",
      });

      L.DomEvent.on(button, "click", (e) => {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        onClick();
      });

      return container;
    };

    control.addTo(map);

    return () => {
      control.remove();
    };
  }, [map]);

  return null;
};

export default MapDownloadControl;
